<template>
	<div class="main" v-title data-title="零部件基本资料">
		<iHeader ref="loginIndex"></iHeader>
		<div class="flexRow justBetween barprebox mt25">
			<vnav></vnav>
			<div class="contR pdb30 bgwhite">
				<div class="mt25 ml20">
					<div class="Ctitle">
						<h1 class="color1 font18 item1">收货地址</h1>
						<el-button type="primary" plain size="small" class="fr pdr20" @click="add">添加地址</el-button>
						<div class="addline clearfix" v-for="item in addressdata" v-if="addressdata.length>0">
							<div class="addresshead fl" style="vertical-align: middle;    margin-top: 20px; letter-spacing: 30px; padding-left: 15px;">{{item.contacts}}</div>
							<div class="fl ml20">
								<p class="username"><span>{{item.contacts}}</span><span class="tel">{{item.mobile}}</span></p>
								<p class="address">{{item.province.name}}{{item.city.name}}{{item.area.name}}{{item.address}}<span class="check"
									 v-if="item.status==1">默认</span></p>
							</div>
							<div class="mt25 fr">
								<el-button type="primary" size="small" @click="editadd(item.id)">编辑</el-button>
								<el-button type="danger" size="small" @click="del(item.id)" plain>删除</el-button>
							</div>
						</div>
						<div class="clearfix" v-if="addressdata.length==0">
							<p class="txc">暂无收货地址</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<v-footer></v-footer>
		<!-- 收货地址弹窗 -->
		<el-dialog title="收货地址" :visible.sync="dialogFormVisible" class="txl">
			<el-form :model="form" class="demo-ruleForm">
				<el-form-item label="姓名" :label-width="formLabelWidth" prop="name">
					<el-input v-model="form.name" autocomplete="off"  style="width: 250px;"placeholder="请输入收货人姓名"></el-input>
				</el-form-item>
				<el-form-item label="固定电话" :label-width="formLabelWidth" prop="phone">
					<el-input v-model="form.qyphone" style="width: 100px; display: inline-block;" autocomplete="off" oninput="if(value.length >4)value = value.slice(0, 4)" type="number" placeholder="请输入区号"></el-input>-
					<el-input v-model="form.zjphone" style="width: 140px; display: inline-block;"autocomplete="off"  oninput="if(value.length >8)value = value.slice(0, 8)" type="number" placeholder="请输入座机"></el-input>
				</el-form-item>
				<el-form-item label="手机号" :label-width="formLabelWidth" prop="phone">
					<el-input v-model="form.phone" autocomplete="off" style="width: 250px;" oninput="if(value.length > 11)value = value.slice(0, 11)"  type="number" placeholder="请输入收货人电话"></el-input>
				</el-form-item>
				<el-form-item label="区域" :label-width="formLabelWidth" prop="uni">
					<el-select v-model="scity.id" value-key="id" placeholder="省" size="mini" @change="citychange" class="linS">
						<el-option v-for="item in scitys" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
					<!--市-->
					<el-select v-model="suni.id" value-key="id" placeholder="市" size="mini" @change="unichange">
						<el-option v-for="item in sunis" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
					<!--区-->
					<el-select v-model="sarea.id" value-key="id" placeholder="区" size="mini" v-if="uniflag==true">
						<el-option v-for="item in sareas" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="详细地址" :label-width="formLabelWidth" prop="address">
					<el-input v-model="form.address" autocomplete="off" placeholder="请输入街道门牌楼层房间等信息"></el-input>
				</el-form-item>
				<el-form-item label="邮政编码" :label-width="formLabelWidth" prop="postal_code">
					<el-input v-model="form.postal_code" autocomplete="off"style="width: 250px;" type="number" oninput="if(value.length >6)value = value.slice(0, 6)" placeholder="请输入邮政编码"></el-input>
				</el-form-item>
				<el-form-item label="设为默认地址" :label-width="formLabelWidth" prop="defaultAddress">
					<el-switch v-model="form.defaultAddress" @change="defaultAddress"></el-switch>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="editaddsave">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	// 公共头部组件
	import Cookies from 'js-cookie'
	import iHeader from "@/components/indexheader"
	import vnav from "@/components/leftnav"
	import vFooter from "@/components/Footer"
	import VDistpicker from 'v-distpicker'
	import "@/assets/cont-01.css";
	import Vue from 'vue';
	import axios from 'axios';
	Vue.prototype.$axios = axios;
	export default {
		components: {
			iHeader,
			vFooter,
			VDistpicker,
			vnav,
		},
		data() {
			return {
				titleDec: "零部件",
				dialogFormVisible: false,
				id: '',
				userid: '',
				ticket: '',
				addressdata: [],
				page: 1,
				pcount: 1,
				total: 1,
				form: {
					name: '',
					phone: '',
					address: '',
					acd: '',
					defaultAddress: false,
					status: 1,
					postal_code: '',
					qyphone:'',
					zjphone:''
				},
				formLabelWidth: '100px',
				// 省市区
				scity: {},
				suni: {},
				sarea: {},
				scitys: [],
				sunis: [],
				sareas: [],
				uniflag: true
			}
		},
		created() {
			// 省市区
			this.handecity(1);
			if (Cookies.get('mf_service_ticket') !== undefined) {
				this.ticket = Cookies.get('mf_service_ticket').split('.');
				this.userid = Cookies.get('userid');
			}
			this.address();
		},
		methods: {
			validateZipCode(str) {
				const reg = /^[1-9][0-9]{5}$/
				return reg.test(str)
			},
			validateAreaPhone(str){
				const reg=/((^0\d{2,3}(\-)?)?\d{7,8}$)|((^86(\-)?\d{2,3}(\-)?)?\d{7,8}$)/
				return reg.test(str)
			},
			// 省市区
			handecity(pid, type) {
				this.$postcn('partshome/wholeCountryCity', {
					pid: pid
				}, this).then((res) => {
					if (res.status == 200) {
						if (pid == 1) {
							this.scitys = res.data
						} else if (type == 'city') {
							this.sunis = res.data
						} else if (type == 'area') {
							if (res.data.length == 0) {
								this.uniflag = false
							} else {
								this.uniflag = true
								this.sareas = res.data
							}
						}
					}
				})
			},
			citychange(value) {
				if (value !== "") {
					this.handecity(value, "city");
				}
				this.suni = {}
				this.sarea = {}
			},
			unichange(value) {
				if (value !== "") {
					this.handecity(value, "area");
				}
			},
			add() {
				this.dialogFormVisible = true
				this.form.name = '';
				this.form.phone = '';
				this.form.address = '';
				// this.form.postal_code = '';
				this.form.defaultAddress = false
				this.scity = {};
				this.suni = {};
				this.sarea = {};
				this.id ='';
			},
			defaultAddress(e) {
				this.form.defaultAddress = e;
				if (e == true) {
					this.form.status = 1
				} else {
					this.form.status = 2
				}
			},
			editadd(id) {
				this.id = id;
				this.dialogFormVisible = true
				if (id != '' && id != undefined) {
					this.$postcn('partshome/getaddressinfo', {
						'id': id
					}, this).then((res) => {
						if (res.status == 200) {
							this.form.name = res.data.data.contacts;
							this.form.phone = res.data.data.mobile;
							this.form.address = res.data.data.address;
							if (res.data.data.postal_code != '') {
								this.form.postal_code = res.data.data.postal_code;
							}
							if (res.data.data.status == 1) {
								this.form.defaultAddress = true
							} else {
								this.form.defaultAddress = false
							}
							this.scity = res.data.data.province;
							this.suni = res.data.data.city;
							this.sarea = res.data.data.area;
							this.form.qyphone=res.data.data.telephone[0];
							this.form.zjphone=res.data.data.telephone[1];
							this.handecity(res.data.data.province.id, 'city');
							this.handecity(res.data.data.city.id, 'area');
						}
					})
				} else {
					this.form.name = '';
					this.form.phone = '';
					this.form.address = '';
					this.form.postal_code = '';
					this.form.defaultAddress = false
					this.scity ={};
					this.suni = {};
					this.sarea = {};
				}

			},
			editaddsave() {
				if (this.form.postal_code != "" && this.validateZipCode(this.form.postal_code) == false) {
					this.$message({
						type: 'error',
						message: "请输入正确的邮政编码"
					});
				} else if(this.form.qyphone!= "" && this.form.zjphone!="" && this.validateAreaPhone(this.form.qyphone+'-'+this.form.zjphone) == false){
					this.$message({
						type: 'error',
						message: "请输入正确的区号座机"
					});
				}else {
					// if(this.sarea.id==undefined){
					// 	 this.sarea.id='0'
					// }
					this.$postcn('partshome/AddAddress', {
						'id': this.id,
						'userid': this.userid,
						'postal_code': this.form.postal_code,
						'province': this.scity.id,
						'city': this.suni.id,
						'area': this.sarea.id,
						'address': this.form.address,
						'mobile': this.form.phone,
						'contacts': this.form.name,
						'status': this.form.status,
						'telephone':this.form.qyphone+'-'+this.form.zjphone
					}, this).then((res) => {
						if (res.data.code != -1) {
							this.dialogFormVisible = false
							this.$message({
								type: 'success',
								message: res.data.msg
							});
							this.address();
						} else {
							this.$message({
								type: 'error',
								message: res.data.msg
							});
						}
					})
				}
			},
			address() {
				this.$postcn('partshome/EditAddress', {}, this).then((res) => {
					if (res.status == 200&&res.data.code!=-4004) {
						this.addressdata = res.data
					} else if(res.data.code==-4004){
						this.$refs.loginIndex.handLogin(window.location.href)
					}else {
						this.$message({
							type: 'error',
							message: '数据错误'
						});
					}
				})
			},
			del(id) {
				this.$confirm('确定要删除该地址吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					// 调取接口
					this.$postcn('partshome/DeleteAddress', {
						'id': id,
						'userid': this.userid
					}, this).then((res) => {
						// console.log("deladdress",res)
						if (res.status == 200) {
							this.address();
						} else {
							this.$message({
								type: 'error',
								message: res.data.msg
							});
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			}

		}
	}
</script>

<style style="scoped">
	.clearfix {
		width: auto;
		height: auto;
	}

	.clearfix:after {
		content: ".";
		display: block;
		height: 0;
		clear: both;
		visibility: hidden;
		font-size: 0;
	}

	.item1 {
		display: inline-block;
	}

	/* .formW {
		width: 600PX;
		margin-top: 40PX;

	} */

	input[type=number] {
		-moz-appearance: textfield;
	}

	input[type=number]::-webkit-inner-spin-button,
	input[type=number]::-webkit-outer-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}

	.Ctitle {
		height: 48px;
		line-height: 48px;
		vertical-align: middle;
		margin-right: 20px;
		border-bottom: 1px solid #ccc;
	}

	.el-dialog {
		width: 30% !important;
	}

	.el-input__inner {
		font-size: 14px;
		padding-left: 10px !important;
	}

	.el-avatar {
		width: 50px;
		height: 50px;
	}

	.username {
		padding-top: 20px;
		line-height: 25px;
	}

	.address {
		line-height: 25px;
	}

	.check {
		color: #f56c6c;
		background: #fef0f0;
		padding: 3px 5px;
		font-size: 14px;
		/* border-radius: 4px;
    border: 1px solid #fbc4c4; */
	}

	.tel {
		font-size: 12px;
		color: #9a9a9a;
		margin-left: 10px;
	}

	.addline {
		/* height: 88px; */
		border-bottom: 1px solid #e4e7ed;
		padding-bottom: 10px;
		margin-bottom: 10px;
	}

	.addresshead {
		display: inline-block;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		text-align: center;
		color: #fff;
		background: #C0C4CC;
		width: 50px;
		height: 50px;
		line-height: 50px;
		font-size: 20px;
		border-radius: 50%;
	}
</style>
<style>
	.Ctitle .el-button--primary.is-plain:hover {
		background-color: #005dbe !important;
		color: #FFFFFF !important;
		border: 1px solid #005dbe;
	}

	.Ctitle .el-button--primary.is-plain {
		color: #005dbe;
		background: #ffffff;
		border-color: #005dbe;
	}
</style>



// WEBPACK FOOTER //
// src/pages/people/address.vue